{
  "eyebrow": "Fatturazione e pagamento",
  "title": "Ci siamo quasi.",
  "sub": "Prosegui alla cassa sicura per iniziare la prova di 30 giorni. Oggi non ti addebiteremo nulla.",
  "summary": {
    "plan": "Piano",
    "cycle": "Ciclo di fatturazione",
    "users": "Utenti",
    "vtt": "Vehicle Track & Trace",
    "vehicles": "Veicoli",
    "total": "Totale stimato / mese",
    "vttOn": "Incluso"
  },
  "secureNote": "Cassa sicura tramite Stripe · 30 giorni di prova · Annulla quando vuoi",
  "continue": "Prosegui su Stripe",
  "submitting": "Apertura di Stripe…",
  "canceled": {
    "title": "Pagamento annullato",
    "sub": "Nessun addebito effettuato. Riprova o contattaci se ti serve aiuto.",
    "retry": "Riprova"
  },
  "promo": {
    "toggle": "Hai un codice promozionale?",
    "placeholder": "Codice promozionale",
    "apply": "Applica",
    "chip": "{{percent}}% di sconto",
    "remove": "Rimuovi codice promozionale",
    "errorGeneric": "Impossibile verificare il codice. Riprova."
  },
  "errors": {
    "generic": "Impossibile avviare il pagamento. Riprova."
  },
  "totalUnavailable": "Catalogo prezzi non disponibile. Riprova per caricare i prezzi più recenti."
}
